import { cn } from '@legalcrm/ui';
import type { ReactNode } from 'react';

export interface PageHeaderProps {
  title: ReactNode;
  description?: ReactNode;
  /** Buttons and menus. Right-aligned; wraps below the title on narrow screens. */
  actions?: ReactNode;
  /** Status pills, counts, the record's reference. Rendered under the title. */
  meta?: ReactNode;
  className?: string;
}

/** One page heading treatment, so every screen looks like the same product. */
export function PageHeader({ title, description, actions, meta, className }: PageHeaderProps) {
  return (
    <div className={cn('mb-5 flex flex-wrap items-start justify-between gap-3', className)}>
      <div className="min-w-0">
        <h1 className="font-display text-3xl font-medium tracking-tight text-ink">{title}</h1>
        {description && <p className="mt-1 max-w-2xl text-sm text-ink-muted">{description}</p>}
        {meta && <div className="mt-2 flex flex-wrap items-center gap-2">{meta}</div>}
      </div>
      {actions && <div className="flex shrink-0 flex-wrap items-center gap-2">{actions}</div>}
    </div>
  );
}
